/*
创建者 魏强(2018.1.25)
企业品牌网店
*/
<template>
  <div id="new-shop-page">
    <banner :data="bannerList" v-if="bannerList.length>0"></banner>
    <div class="wrapper">
      <!-- 精品速递 -->
      <boutique :data="jpsdGoodsAdvList" v-if="jpsdGoodsAdvList.length>0"> </boutique>
      <!-- 企业品牌 -->
      <store-list :data="storePinPaiList" v-if="storePinPaiList.length>0"></store-list>
    </div>
  </div>
</template>
<script>
import banner from './banner';
import boutique from './boutique';
import storeList from './store-list';
import {pinpainew} from 'api/home';
import {parseAdvList} from 'utils/tool';
export default {
  components:{
    banner,
    boutique,
    storeList
  },
  data () {
      return {
        storePinPaiList:[],
        jpsdGoodsAdvList:[],
        bannerList:[]
      }
  },
  created(){
    this.fetchData();
  },
  methods:{
    fetchData(){
      pinpainew().then(json=>{
        if(json.resCode==1){
          let data = json.data;
          this.storePinPaiList = data.storeDetailDTOList;
          this.jpsdGoodsAdvList = parseAdvList(data.courierAdvertisementDTO.advList);
          this.bannerList = parseAdvList(data.homeBannerAdvertisementDTO.advList);
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?cc2c3868